/**
 * Outside-Frame Selection Zone Constraints
 * 
 * Used by both CameraTrajectoryOverlay and NavigationHintOverlay
 * to ensure consistent behavior for zone visualization and candidate selection
 */

export const OUTSIDE_FRAME_ZONE = {
  minDistancePercent: 0.5,  // 50% - minimum distance from frame edge
  maxDistancePercent: 3.0,  // 300% - maximum distance from frame edge
  perpendularAlignmentPercent: 0.5, // ±50% - allowed deviation on perpendicular axis
} as const
